import { Box, Skeleton, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function UsageLoader() {
  const theme = useTheme();

  return (
    <>
      <Grid container spacing={3}>
        {[1, 2, 3, 4].map((idx) => (
          <Grid key={`skeleton-card-${idx}`} size={{ xs: 12, sm: 6, lg: 3 }}>
            <Box bgcolor='#fff' border='1px solid #ECECEC' px={2} py={1.5} borderRadius={2} minHeight={112}>
              <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Skeleton variant='text' width={100} height={20} />
                <Skeleton variant='circular' width={32} height={32} sx={{ bgcolor: theme.palette.action.hover }} />
              </Box>
              <Skeleton variant='text' width={80} height={36} sx={{ mt: 1 }} />
              <Skeleton variant='text' width='70%' height={16} sx={{ mt: 1 }} />
            </Box>
          </Grid>
        ))}
      </Grid>

      <Skeleton variant='text' width={180} height={32} sx={{ mt: 3 }} />
      <Skeleton variant='text' width={280} height={20} sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        {[1, 2, 3, 4, 5, 6].map((idx) => (
          <Grid key={`skeleton-meter-${idx}`} size={{ xs: 12, md: 6 }}>
            <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius='10px' px={2} py={1.5}>
              <Box display='flex' alignItems='center' gap={1.25} pb={1.5} borderBottom='1px solid #ECECEC'>
                <Skeleton variant='circular' width={32} height={32} sx={{ bgcolor: theme.palette.action.hover }} />
                <Skeleton variant='text' width={140} height={22} />
              </Box>
              <Box display='flex' justifyContent='space-between' mt={1.5}>
                <Skeleton variant='text' width={160} height={18} />
                <Skeleton variant='text' width={80} height={22} />
              </Box>
              <Skeleton variant='rounded' height={8} sx={{ mt: 1, borderRadius: 5 }} />
              <Box display='flex' justifyContent='space-between' mt={0.75}>
                <Skeleton variant='text' width={180} height={16} />
                <Skeleton variant='text' width={60} height={16} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
